export { default as ChileRating } from './chile-rating';
